<template>
  <div class="sign">
    <div class="sign-search">
      <div class="btn-box">
        <van-field
          size="small"
          v-model="key"
          placeholder="采购单/提货单/进仓单/参考号"
          :formatter="relationNumberFmt"
          @keyup.13="getList()"
        />
      </div>

      <div class="toSearch-box">
        <button class="sign-toSearch" @click="getList()">查询</button>
      </div>
    </div>

    <div class="sign-item">
      <template v-if="startSearch">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </template>
      <template v-else>
        <template v-if="list.length">
          <ul>
            <li
              @click="toDetail(item)"
              v-for="(item, index) in list"
              :key="index"
            >
              <div class="sign-list">
                <strong>单号信息</strong>
              </div>
              <div class="sign-list">
                <p>单号：{{ item.trackNumber }}</p>
                <p>箱数：{{ item.boxCount }}</p>
              </div>
              <div class="sign-list">
                <p>总重量：{{ item.totalWeight }}</p>
                <p>总体积：{{ item.totalVolume }}</p>
              </div>
              <span v-if="item.bussbusinessType !== 2">
                <div class="sign-list">
                  <strong>产品信息</strong>
                </div>
                <div class="sign-list">
                  <p>SKU：{{ item.sku }}</p>
                </div>
                <div class="sign-list">
                  <p>数量：{{ item.totalQty }}</p>
                </div>
              </span>
              <div class="sign-list">
                <strong>送货地址</strong>
              </div>
              <div class="sign-list">
                <p>
                  {{ item.address }}<br />{{ item.contacter }} {{ item.phone }}
                </p>
              </div>
            </li>
          </ul>
        </template>
        <template v-else>
          <van-empty image="search" description="暂无数据" />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Empty,
  List,
  PullRefresh,
  cell,
  Toast,
  Loading,
} from "vant";
import { getMakeAppointmentList } from "@/api/mobile_Reserve/mobileReserve_api";
import { mapState } from "vuex";
import util from "util/date";
import { debounce, getUrlParams } from "util/util";

export default {
  data() {
    return {
      list: [],
      loading: false,
      startSearch: false,
      key: "",
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Empty.name]: Empty,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [cell.name]: cell,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Field.name]: Field,
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      let params = getUrlParams(window.location.href);
      if (params && params.key) {
        this.key = params.key;
        this.getList();
      }
    },
    getList() {
      if (!this.key) return Toast("请输入搜索内容");

      this.list = [];

      this.startSearch = true;

      getMakeAppointmentList({ key: this.key }).then((res) => {
        this.startSearch = false;
        this.loading = false;
        if (res.status === 200 && res.success) {
          const { response } = res;

          if (!response.length) return Toast("暂无匹配数据");

          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    toDetail(item) {
      this.$router.push({
        path: "/mobile/appointmentDetail",
        query: { ...item },
      });
    },
    relationNumberFmt(v) {
      return v.trim();
    },
  },
  watch: {
    $route: async function (newValue, from) {
      this.$nextTick(() => {
        if (newValue.path === "/mobile/reserveItems") {
          this.list = [];
          this.key = "";
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .van-cell {
  border: 1px solid #adadad;
  margin-bottom: 7px;
  padding: 5px 10px;
}
.sign {
  // background-color: #fbf9fe;
}
.sign-search {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 10px 3px 10px;
  display: flex;
}
.sign-search .btn-box {
  flex: 0.6;
}
.sign-search .toSearch-box {
  flex: 0.4;
  margin-left: 3%;
  min-height: 25px;
}
.sign-toSearch {
  width: 100%;
  height: 84%;
  min-height: 25px;
  background: linear-gradient(to right, #1d62f0 0%, #19d4fd 100%);
  border-radius: 5px;
  border: 0;
  color: #fff;
  font-size: 18px;
}
.toSearch-box {
  vertical-align: top;
}
.sign-item {
  border-top: 1px solid #ccc;
}
.sign-item li {
  border-bottom: 1px solid #ccc;
  // background-color: #fbf9fe;
  padding: 3px 10px;
  font-size: 12px;
}
.sign-list {
  display: flex;
  margin: 5px 0;
  p {
    flex: 1;
    word-break: break-all;
    margin: 0;
  }
}
</style>